import { Tooltip } from '@mantine/core'
import { Info } from 'lucide-react'

interface SectionInfoIconProps {
  tooltip: React.ReactNode
  /**
   * Names the hint for screen readers, which never see the tooltip's own text
   * until it is opened. Defaults to something generic; pass the section name
   * where several hints sit on one page.
   */
  ariaLabel?: string
}

export const SectionInfoIcon = ({
  tooltip,
  ariaLabel = 'More information',
}: SectionInfoIconProps) => (
  <Tooltip
    label={
      typeof tooltip === 'string' ? (
        <span style={{ whiteSpace: 'pre-line', fontSize: 12 }}>{tooltip}</span>
      ) : (
        tooltip
      )
    }
    multiline
    w={300}
    withArrow
    position="top"
    // Mantine leaves focus off by default, so without this the tooltip opens
    // for a mouse only and the text stays unreachable from the keyboard.
    events={{ hover: true, focus: true, touch: true }}
  >
    {/*
      A bare <svg> cannot take focus, so the tooltip's focus event never fires
      and the text is unreachable without a mouse. The button is the focusable
      target; it carries no styling of its own so the icon looks unchanged.
    */}
    <button
      type="button"
      aria-label={ariaLabel}
      className="inline-flex cursor-help items-center justify-center border-0 bg-transparent p-0"
    >
      <Info size={15} className="text-gray-400" />
    </button>
  </Tooltip>
)
